var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z"}));
}

ArrowUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
